import React from 'react';
import { Link } from 'react-router-dom';
import LocalLaundryServiceIcon from '@material-ui/icons/LocalLaundryService';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddMachineButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="raised"
    component={Link}
    to={`/machines/create?buildingId=${record.id}`}
    label="Añadir una máquina"
    title="Añadir una máquina"
  >
    <LocalLaundryServiceIcon />
  </Button>
);

export default withStyles(styles)(AddMachineButton);
